<div class="sub-header-container">
  <app-layout-main size="medium" padding="md">
    <div class="layout-sub-header">
      <ng-content />
    </div>
  </app-layout-main>
</div>
